import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransportStart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 8,
	viewBox: "0 0 16 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 1H3.5M6.5 1H3.5M3.5 1V8",
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 4.5H9.5",
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M9.5 1H12.5M15.5 1H12.5M12.5 1V8",
			stroke: "black",
			strokeWidth: 1.5
		})
	]
});
export default SvgTransportStart;
